/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { HTTP_METHOD } from "@nf/constants";
import { httpService } from "../../../../services";
import { IChannelModel } from "../models";

export class ChannelService {
  get url(): string {
    return "/v1";
  }

  public onNow = (
    channelId: string,
    minutesForward?: number
  ): Promise<IChannelModel> =>
    httpService.request<IChannelModel>({
      method: HTTP_METHOD.GET,
      url: `${this.url}/channel/onnow/${channelId}`,
      axiosConfig: minutesForward
        ? { params: { minutesForward } }
        : undefined,
    });
}
